// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1n2DU","content":"GlobalSearch_content__KJ8lN"};